var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { Content, Wrapper as Component } from './Expand.styled';
import { getAutomation, getDebug, useEventListener } from '@citrus/runtime';
import { isNotNilOrEmpty, isNotNullOrEmpty } from '@pcty/utils';
import { getChildByType, getChildByTypeDeep } from 'react-nanny';
import { Icon } from '@citrus/icon';
import { useTheme } from '@citrus/user';
var VERSION = '1.2.1-CDS3668.1';
var Expand = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, _c = _a.collapsedHeight, collapsedHeight = _c === void 0 ? 100 : _c, css = _a.css, expanded = _a.expanded, id = _a.id, renderButton = _a.renderButton, _d = _a.__TYPE, TYPE = _d === void 0 ? 'Expand' : _d, other = __rest(_a, ["automationId", "children", "className", "collapsedHeight", "css", "expanded", "id", "renderButton", "__TYPE"]);
    var isCitron = useTheme().citrus2022;
    var contentRef = useRef(null);
    var _e = useState(), overflowing = _e[0], setOverflowing = _e[1];
    var _f = useState('10000px'), maxHeight = _f[0], setMaxHeight = _f[1];
    var _g = useState(window.innerWidth), windowSize = _g[0], setWindowSize = _g[1];
    useEventListener('resize', function () { return setWindowSize(window.innerWidth); });
    useEffect(function () { return setOverflowing(contentRef.current.scrollHeight > collapsedHeight); }, [children]);
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var button = getChildByTypeDeep(renderButton(), ['BorderlessButton']);
    useEffect(function () {
        if (expanded) {
            contentRef.current.style.maxHeight = '10000px';
        }
        else
            setMaxHeight('10000px');
    }, [windowSize]);
    useEffect(function () {
        if (contentRef.current.offsetHeight !== 0 && contentRef.current.offsetHeight !== maxHeight.replace('px', '')) {
            setMaxHeight("".concat(contentRef.current.offsetHeight, "px"));
        }
    }, [expanded, children]);
    useEffect(function () {
        if (expanded) {
            if (contentRef.current.style.maxHeight !== '0px') {
                contentRef.current.style.maxHeight = "".concat(contentRef.current.offsetHeight, "px");
            }
            else
                contentRef.current.style.maxHeight = maxHeight;
        }
        else
            contentRef.current.style.maxHeight = collapsedHeight;
    }, [expanded, children]);
    if (isNotNilOrEmpty(button)) {
        button = React.cloneElement(button, { size: isCitron ? 'small' : 'medium', style: { marginBottom: isCitron ? 16 : 0 } }, [
            React.createElement(Icon, { key: "expand-icon", name: expanded ? 'chevron-up' : 'chevron-down' }),
            getChildByType(button.props.children, ['string']),
        ]);
    }
    return (React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)),
        React.createElement(Content, __assign({ className: expanded
                ? 'open'
                : "".concat(emotionCss({
                    height: collapsedHeight,
                }), " closed"), ref: contentRef }, getAutomation(automationId, 'content')), children),
        overflowing && button));
});
Expand.defaultProps = {
    __TYPE: 'Expand',
};
export default Expand;
